import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Modal, Button, Spinner } from "react-bootstrap";
import { BASE_URL } from "./Baseurl";
import { useParams } from "react-router-dom";
import NavbarVisitor from "./NavbarVisitor";
import DummyInput from "./DummyInput";
import Swal from 'sweetalert2'; 

const CustomForm = () => {

const {id, title} = useParams();

const [formData, setFormData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [formValues, setFormValues] = useState({});
  const [selectedVariant, setSelectedVariant] = useState("");
const navigate = useNavigate();


  useEffect(() => {
    if (!id) return;

    const fetchForm = async () => {
      try {
        const response = await axios.get(`${BASE_URL}getFormByEventId/${id}`);
        setFormData(response.data.form);
      } catch (error) {
        console.error("Error fetching form:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchForm();
  }, [id]);

  if (loading) return <p>Loading form...</p>;
  if (!formData) return <p>No form found.</p>;

  const handleChange = (id, value) => {
    setFormValues((prev) => ({
      ...prev,
      [id]: value,
    }));
  };

  const handleCheckboxChange = (id, value) => {
    const currentValues = formValues[id] || [];
    const updatedValues = currentValues.includes(value)
      ? currentValues.filter((val) => val !== value)
      : [...currentValues, value];

    setFormValues((prev) => ({
      ...prev,
      [id]: updatedValues,
    }));
  };

  const renderField = (field) => {
    const { id, type, label, options, isRequired } = field;

    switch (type) {
      case "input":
        return (
          <div className="mb-3 col-md-6" key={id}>
            <label className="form-label">{label} {isRequired && <span className="text-danger">*</span>}</label>
            <input
              type="text"
              className="form-control"
              value={formValues[id] || ""}
              onChange={(e) => handleChange(id, e.target.value)}
              required={isRequired}
            />
          </div>
        );

      case "textarea":
        return (
          <div className="mb-3 col-md-6" key={id}>
            <label className="form-label">{label} {isRequired && <span className="text-danger">*</span>}</label>
            <textarea
              className="form-control"
              value={formValues[id] || ""}
              onChange={(e) => handleChange(id, e.target.value)}
              required={isRequired}
            ></textarea>
          </div>
        );

      case "select":
        return (
          <div className="mb-3 col-md-6" key={id}>
            <label className="form-label">{label} {isRequired && <span className="text-danger">*</span>}</label>
            <select
              className="form-select"
              value={formValues[id] || ""}
              onChange={(e) => handleChange(id, e.target.value)}
              required={isRequired}
            >
              <option value="">Select an option</option>
              {options.map((opt, idx) => (
                <option key={idx} value={opt}>{opt}</option>
              ))}
            </select>
          </div>
        );

      case "checkbox":
        return (
          <div className="mb-3 col-md-6" key={id}>
            <label className="form-label d-block">{label} {isRequired && <span className="text-danger">*</span>}</label>
            {options.map((opt, idx) => (
              <div className="form-check form-check-inline" key={idx}>
                <input
                  className="form-check-input"
                  type="checkbox"
                  checked={(formValues[id] || []).includes(opt)}
                  onChange={() => handleCheckboxChange(id, opt)}
                />
                <label className="form-check-label">{opt}</label>
              </div>
            ))}
          </div>
        );

      case "radio":
        return (
          <div className="mb-3 col-md-6" key={id}>
            <label className="form-label d-block">{label} {isRequired && <span className="text-danger">*</span>}</label>
            {options.map((opt, idx) => (
              <div className="form-check form-check-inline" key={idx}>
                <input
                  className="form-check-input"
                  type="radio"
                  name={label}
                  value={opt}
                  checked={formValues[id] === opt}
                  onChange={(e) => handleChange(id, e.target.value)}
                />
                <label className="form-check-label">{opt}</label>
              </div>
            ))}
          </div>
        );

      case "file":
        return (
          <div className="mb-3  col-md-6" key={id}>
            <label className="form-label">{label} {isRequired && <span className="text-danger">*</span>}</label>
            <input
              type="file"
              className="form-control"
              onChange={(e) => handleChange(id, e.target.files[0])}
              required={isRequired}
            />
          </div>
        );

      default:
        return null;
    }
  };

const visitorId = localStorage.getItem("visitor_id");

const handleSubmit = async (e) => {
  e.preventDefault();

  const payload = {
    user_id: visitorId,
    form_id: formData.id,
    submission_data: {
      ...formValues,
      pricingSelection: selectedVariant,
    },
  };

  console.log("Submitted Data:", payload);

  try {
    const response = await axios.post(`${BASE_URL}submitCustForm`, payload);
    console.log("Submission success:", response.data);

    await Swal.fire({
      icon: 'success',
      title: 'Success!',
      text: 'Form submitted successfully.',
      confirmButtonColor: '#3085d6',
      confirmButtonText: 'OK'
    });

    navigate(-1); // Go back to previous page
  } catch (error) {
    console.error("Error submitting form:", error);
    Swal.fire({
      icon: 'error',
      title: 'Oops...',
      text: 'Failed to submit form.',
      confirmButtonColor: '#d33'
    });
  }
};

  const { pricing } = formData;


  return (
    <>
      
      <NavbarVisitor/>


 <div className="container mt-4 mb-5" style={{ maxWidth: '900px' }}>
      <div className="card shadow">
        <div className="card-body">
          <h3 className="card-title mb-4 classic-form-title">{formData.title}</h3>

          {/* <h5 className="text-muted mb-3">Form Type: {formData.formtype}</h5> */}
 
<DummyInput/>
 
          <form onSubmit={handleSubmit} className="text-start">

            <div className="row  g-2 mt-3">
{formData.fields && formData.fields.map(renderField)}
            </div>
            

            {pricing?.isPaid === "paid" && (
  <div className="pricing-section">
    <h4>Pricing</h4>

    {pricing.perTicketPricing === "yes" ? (
      <div>
        <p><strong>Select Ticket Type:</strong></p>
        {pricing.variants.map((variant, index) => (
          <div className="form-check pricing-option" key={index}>
            <input
              type="radio"
              className="form-check-input"
              name="pricing"
              value={variant.type}
              onChange={(e) => setSelectedVariant(variant)}
              required
            />
            <label className="form-check-label">
              {variant.type} - {pricing.currency} {variant.price}
            </label>
          </div>
        ))}
      </div>
    ) : (
      <p><strong>Price:</strong> {pricing.currency} {pricing.price}</p>
    )}
  </div>
)}


            <button type="submit" className="btn btn-primary mt-4">
              Submit
            </button>
          </form>
        </div>
      </div>
    </div>







    </>
  );
};

export default CustomForm;